<div class="agreement-form-area body-data">
    <div class="agreement-area">
        <table class="form-container" style="overflow: hidden;" cellspacing="0"  class="comp">
          <tr>
            <!-- <div class="right-area" style="margin: 0px;" >
                <mat-icon  class="cls-btn" (click)="onCloseBtn()">close</mat-icon>
            </div> -->
            <div class="title">Add A New Rate Table</div>
            <span style="position: relative; left: 12px;">Choose the format that best suits your needs:</span>
          </tr>
  
          <tr class="accord-area">
            <div class="card-item">
                <div class="title">FTL Matrix</div>
                <span>Rates for shipping a full truckload of freight.</span>
                <img src="../../../../assets/images/ftl.png">
                <button class="btn white-red-btn" (click)="onSelectFormat('ftl')">Select Format</button>
            </div>

            <div class="card-item">
                <div class="title">FTL Fix Price Matrix</div>
                <span>Pre-defined rates for specific FTL shipping lanes or routes.</span>
                <img src="../../../../assets/images/ftl_fixed.png">
                <button class="btn white-red-btn" (click)="onSelectFormat('fixed')">Select Format</button>
            </div>

            <div class="card-item">
                <div class="title">LTL Matrix</div>
                <span>Rates for shipping smaller shipments that share space on a truck with other cargo.</span>
                <img src="../../../../assets/images/ltl.png">
                <button class="btn white-red-btn" (click)="onSelectFormat('ltl')">Select Format</button>
            </div>
            </tr>
            <!-- <tr *ngIf="dialogRef">
                <div class="right-area">
                    <button class="btn white-red-btn" style="width: 100px;" (click)="onCloseBtn()">Cancel</button>
                </div>
            </tr> -->
        </table>
    </div>
    
</div>